import Button from '@/components/atoms/Button';
import { Skeleton } from '@/components/atoms/Skeleton';
import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';
import { Fragment } from 'react';
import { useTheme } from 'styled-components';
import { ListagemCategoriasProps } from '../..';

export default function ListagemCategoriasMobile(
  props: ListagemCategoriasProps,
) {
  const {
    $key,
    $categorias,
    $categoriaSelecionada,
    $funcaoCliqueCategoria,
    style,
  } = props;

  const theme = useTheme();

  return (
    <ScrollAreaContainer key={$key} orientacao="horizontal">
      <div
        key={`div_categoria_${$key}`}
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: theme.spacing[4],
          ...style,
        }}
      >
        {$categorias.length < 2 ? (
          <Fragment key="skeleton_categoria">
            <Skeleton
              key="skeleton_categoria_1"
              style={{ width: 68, height: 38, marginRight: 16 }}
            />
            <Skeleton
              key="skeleton_categoria_2"
              style={{ width: 99, height: 38, marginRight: 16 }}
            />
            <Skeleton
              key="skeleton_categoria_3"
              style={{ width: 75, height: 38, marginRight: 16 }}
            />
          </Fragment>
        ) : (
          $categorias.map((categoria, index) => (
            <Fragment key={categoria?.nome}>
              <Button
                $size={2}
                $variant="outline"
                $active={index === $categoriaSelecionada}
                $disable={index === $categoriaSelecionada}
                $color="accent"
                $highContrast={false}
                $loading={false}
                $focusRing={false}
                $text={categoria.nome}
                $onClick={() =>
                  $funcaoCliqueCategoria({
                    categoria,
                    index,
                  })
                }
              />
            </Fragment>
          ))
        )}
      </div>
    </ScrollAreaContainer>
  );
}
